import { useState, useEffect } from "react";

const useIsTotem = () => {
    const [isTotem, setIsTotem] = useState(false);

    useEffect(() => {
        const urlQuery = window.location.search;
        const urlParams = new URLSearchParams(urlQuery);

        if (urlParams.has('totem') && urlParams.get('totem')) {
            setIsTotem(true);
        }
    }, [setIsTotem]);

    return isTotem;
}

export default useIsTotem;
